(function () {
  // Stromo: de WhatsApp-chatknop (Eaze WhatsApp Button-app) rendert zijn eigen
  // pill-knop met tekst "Chat with us" in een open shadow-DOM. Omdat die CSS
  // shadow-encapsulated is, kan de theme-CSS er niet direct bij. Deze injecteert
  // een override-stylesheet IN de shadow root zodat alleen het logo overblijft.
  function applyOverrides(root) {
    if (root.querySelector('#stromo-wacb-override')) return;
    var style = document.createElement('style');
    style.id = 'stromo-wacb-override';
    style.textContent = [
      '.gty-wacb-button-text { display: none !important; }',
      '.gty-wacb-button-logo { margin-right: 0 !important; }',
      '.gty-wacb-button {',
      '  width: 46px !important;',
      '  padding-left: 0 !important;',
      '  padding-right: 0 !important;',
      '}'
    ].join('\n');
    root.appendChild(style);
  }

  function tryInit() {
    var el = document.querySelector('gty-whatsapp-chat-button');
    if (el && el.shadowRoot) {
      applyOverrides(el.shadowRoot);
      return true;
    }
    return false;
  }

  if (!tryInit()) {
    var observer = new MutationObserver(function () {
      if (tryInit()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }
})();
